import { Injectable } from '@angular/core';
import jwt_decode from "jwt-decode";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = localStorage.getItem('UserData');
    const isOTPVerified = localStorage.getItem('isOTPVerified');

    

    if (currentUser && isOTPVerified && isOTPVerified == 'true') {
      // logged in so return true
      const decodedCurrentUser = JSON.parse(currentUser)
      if(decodedCurrentUser['CustomerTypeLkp'] == null){ // not customer user
          this.authService.logout();
          return false
      }
      let token = decodedCurrentUser['Token']
      const decodedToken = jwt_decode(token)
      const expiryTime = decodedToken['exp']
      const currTime = new Date().getTime() / 1000
      if(currTime < expiryTime)
        return true;
    }

    // not logged in so redirect to login page with the return url
    this.authService.logout();
    return false;
  }
}
